module.exports = __webpack_public_path__ + "img/ch7.97fc4242.jpg";